import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Icon from '../../atoms/global/Icon';
import FileHolder from '../../organisms/FileHolder';

import ConfirmationModal from '../../molecules/modals/ConfirmationModal';
import HtmlRenderer from '../../organisms/HtmlRenderer';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  isChatOpen,
  isTicketOpen,
  isChatSettingsOpen,
} from '../../../../actions';
import TextEditor from '../editor/TextEditor';
import UserAvatar from '../../atoms/ticket-drawer/UserAvatar';
import { FormattedMessage, useIntl } from 'react-intl';
import UserProfilePopover from '../../../../src-new/components/popovers/UserProfilePopover';
import { deleteComment } from '../../../../redux/messages/actions';
import { TaskButtons } from '../../atoms/buttons/TaskButtons';
import { prepareContentForSending } from '../editor/utils/editorContentOperations';
import TextEditorWrapper from '../editor/TextEditorWrapper';
import { socketSendAction } from '../../../../redux/state-areas/socket/actions';

const DrawerCommentSection = (props) => {
  const [editMessage, setEditMessage] = useState(false);
  const [editedValue, setEditedValue] = useState(props.comment);
  const [open, setOpen] = useState(false);

  const task = props?.task;

  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const msgId =
    props?.msgId || new URLSearchParams(location.search).get('msgId');
  const msgParam = new URLSearchParams(location.search).get('msgId');
  const loggedUser = useSelector((state) => state.userReducer.user);
  const { chats } = useSelector((state) => state.chatReducer);

  const { users } = useSelector((state) => state.userReducer);
  const workspace = useSelector(
    (state) => state.workspaceReducer.currentWorkspace,
  );
  const mentionOptions = users.map((user) => ({
    id: user._id,
    value: user.fullName,
    icon: user.avi,
  }));
  const { showHover = true } = props;
  // Delete handler
  const deleteHandler = (messageId) => {
    if (props?.context === 'task') {
      dispatch(
        deleteComment({
          messageId,
          context: props?.context,
          roomId: props.roomId,
          taskId: props.taskId,
        }),
      );
      setOpen(false);
    } else {
      dispatch(
        socketSendAction('delete-reply', {
          replyId: messageId,
          messageId: msgId,
          userId: loggedUser?._id,
          context: props?.context,
          roomId: props.roomId,
        }),
      );
    }

    setOpen(false);
  };

  // Message Edit handler

  const messageEditHandler = (event, messageId) => {
    event?.preventDefault();
    const preparedEditedValue = prepareContentForSending(editedValue);
    if (props?.context == 'task') {
      const messageDetails = {
        messageId,
        editedValue: preparedEditedValue,
        roomId: props.roomId,
        userId: loggedUser?._id,
        context: props?.context,
        taskId: props.taskId,
      };
      dispatch(socketSendAction('edit-message', messageDetails));
    } else if (messageId?.toString() === msgId?.toString()) {
      const messageDetails = {
        messageId,
        editedValue: preparedEditedValue,
        roomId: props.roomId,
        userId: loggedUser?._id,
        parent: msgParam,
        context: props?.context,
      };
      dispatch(socketSendAction('edit-message', messageDetails));
    } else {
      const messageDetails = {
        messageId,
        editedValue: preparedEditedValue,
        roomId: props.roomId,
        userId: loggedUser?._id,
        parent: msgParam,
        context: props?.context,
      };
      dispatch(socketSendAction('edit-reply', messageDetails));
    }
    setEditedValue(preparedEditedValue);
    setEditMessage(false);
  };

  const closeEdit = () => {
    setEditedValue(props.comment);
    setEditMessage(false);
  };

  const handleTextEditorSubmit = (content, trimmedContent) => {
    messageEditHandler(undefined, msgId);
  };

  return (
    <>
      <ConfirmationModal
        title={intl.formatMessage({
          id: 'DELETE_MESSAGE_CONFIRMATION',
          defaultMessage: 'Delete Message?',
        })}
        description={intl.formatMessage({
          id: 'DELETE_MESSAGE_CONFIRMATION_DESCRIPTION',
          defaultMessage: 'Are you sure you want to delete this Message?',
        })}
        isModalOpen={open}
        onCancel={() => setOpen(false)}
        onYesClick={() => deleteHandler(props.msgId)}
      />
      <div
        className={`d-flex reply-comment-drawer  ${props.parentClass || ''}`}
      >
        {props?.senderId === localStorage.getItem('Id') && (
          <div className="commentBox" style={{ cursor: 'pointer', top: '0px' }}>
            <Icon
              name="Edit.svg"
              height="21px"
              className="hover:opacity-60"
              pl="0px"
              onClick={() => {
                setEditMessage(!editMessage);
              }}
            />
            <Icon
              name="delete-red.svg"
              height="20px"
              className="hover:opacity-60"
              pl="0px"
              onClick={() => {
                setOpen(true);
              }}
            />
          </div>
        )}
        <div className="h-10 w-10 rounded">
          {task?.source === 'form' ? (
            <div
              style={{ height: props.height || '26px', width: props.width || '26px' }}
              className="rounded-full bg-indigo-100 flex items-center justify-center shrink-0"
              title="Form submission"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#4f46e5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
              </svg>
            </div>
          ) : (
            <UserAvatar
              alt="icon"
              classNames="mr-3 w-10 h-10 rounded-full object-cover"
              fullName={props.senderName}
              userId={props.senderId}
              src={props.src}
              styles={{
                height: props.height,
                width: props.width,
                objectFit: 'cover',
                borderRadius: '9999px',
              }}
            />
          )}
        </div>
        <div style={{ width: '90%', position: 'relative' }}>
          <div className="d-flex align-center">
            {task?.source !== 'form' ? (
              <UserProfilePopover
                member={users?.find((m) => m?._id == props.senderId)}
                i={0}
                currentWorkspace={workspace?._id}
              >
                <div className={props.nameClass}>{props.name}</div>
              </UserProfilePopover>
            ) : (
              <div className={props.nameClass}>{props.name}</div>
            )}
            <div
              className="ml-2 pt-1"
              style={{ fontSize: '12px', color: '#ADADAD' }}
            >
              {'  ·  ' + props?.hours}
            </div>
          </div>
          {editMessage ? (
            <form
              onSubmit={(event) => messageEditHandler(event, props.msgId)}
              onKeyDown={(e) => {
                if (e?.code === 'Escape') {
                  messageEditHandler(e, props.msgId);
                }
              }}
            >
              <div className="chat-area">
                <TextEditorWrapper
                  placeholder={intl.formatMessage({
                    id: 'REPLY_PLACEHOLDER',
                    defaultMessage: 'Reply...',
                  })}
                  onChange={setEditedValue}
                  onSubmit={handleTextEditorSubmit}
                  content={editedValue}
                  initialContent={props.comment}
                  mentionOptions={mentionOptions}
                />
                <div className="self-end flex">
                  <TaskButtons
                    onCancel={() => closeEdit()}
                    onHandle={(e) => messageEditHandler(e, msgId)}
                  />
                </div>
              </div>
            </form>
          ) : (
            <>
              <div
                style={{
                  marginTop: props.commentPadding,
                  width: props.containerWidth,
                  textAlign: 'inherit',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-line',
                }}
                onClick={async (e) => {
                  const url = e?.target?.href;

                  if (url) {
                    e.preventDefault();

                    let taskIdentifer = url.split('selectedTask=');

                    if (taskIdentifer.length > 1) {
                      const selectedTask = taskIdentifer[1];

                      const params = new URLSearchParams(location.search);
                      params.delete('msgId'); // Remove the specified parameter
                      params.set('selectedTask', selectedTask);
                      // Construct the new URL with updated parameters
                      const newUrl = `${location.pathname}?${params.toString()}`;

                      await dispatch(isChatOpen(false));

                      // Use navigate to replace the current URL
                      navigate(newUrl);

                      await dispatch(isTicketOpen(true));
                    } else {
                      window.open(url, '_blank').focus();
                    }
                  }
                }}
                className={props.commentClass}
              >
                <HtmlRenderer html={editedValue} />
              </div>
              <div className="d-flex" style={{ objectFit: 'cover' }}>
                {props.files &&
                  props.files.map((file) => {
                    return (
                      <FileHolder
                        file={{ name: file?.name, url: file?.signedUrl }}
                      />
                    );
                  })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DrawerCommentSection;
